function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { billListApi, billListEditApi, billListDeleteApi, billListCreateApi, enterprisePayTypeApi, billImportApi } from '@/api/enterprise';
export default {
  name: 'FinanceList',
  components: {
    formBox: function formBox() {
      return import('./components/formBox');
    },
    dialogForm: function dialogForm() {
      return import('./components/index');
    },
    viewDetails: function viewDetails() {
      return import('./components/viewDetails');
    },
    exportExcel: function exportExcel() {
      return import('@/components/common/exportExcel');
    },
    importExcel: function importExcel() {
      return import('@/components/common/importExcel');
    }
  },
  data: function data() {
    return {
      drawer: false,
      input: '',
      detailsData: {},
      fromData: {},
      formBoxConfig: {},
      columnNumber: 3,
      timeVal: [this.$moment().startOf('months').format('YYYY/MM/DD'), this.$moment().endOf('months').format('YYYY/MM/DD')],
      exportData: {
        data: [],
        cols: [{
          wpx: 70
        }, {
          wpx: 70
        }, {
          wpx: 120
        }, {
          wpx: 140
        }, {
          wpx: 120
        }]
      },
      saveName: '',
      where: {
        page: 1,
        limit: 15,
        sort: 'id',
        types: ''
      },
      loading: false,
      itemOptions: [],
      rolesConfig: [],
      tableData: [],
      detailData: null,
      treeData: null,
      companyData: null,
      gettime: '',
      totalExpend: 0,
      totalIncome: 0,
      total: 0
    };
  },
  created: function created() {
    this.where.time = "".concat(this.timeVal[0], "-").concat(this.timeVal[1]);
    this.getTableData();
    this.getPayType();
  },
  methods: {
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTableData();
    },
    getNum: function getNum() {
      var num = 0;
      num = this.totalIncome - this.totalExpend;
      return num.toFixed(2);
    },
    sortChange: function sortChange(column) {
      if (column.order === 'ascending') {
        this.where.sort = column.prop + ' asc';
      } else if (column.order === 'descending') {
        this.where.sort = column.prop + ' desc';
      } else {
        this.where.sort = '';
      }
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTableData();
    },
    // 获取表格数据
    getTableData: function getTableData() {
      var _this = this;
      this.loading = true;
      billListApi(this.where).then(function (res) {
        _this.tableData = res.data.list;
        _this.total = res.data.count;
        _this.loading = false;
        _this.totalExpend = res.data.expend == 0 ? '0.00' : res.data.expend;
        _this.totalIncome = res.data.income == 0 ? '0.00' : res.data.income;
      });
    },
    // 导入
    importExcelData: function importExcelData(data) {
      var _this2 = this;
      if (data[0][0] == '示例：0') {
        data.splice(0, 1);
      }
      var res = [];
      if (data.length <= 0) {
        this.$message.error('批量导出内容为空');
      } else {
        for (var i = 0; i <= data.length - 1; i++) {
          if (data[i][0] === '') {
            continue;
          } else {
            res.push({
              types: data[i][0],
              cate_id: data[i][1],
              mark: data[i][5],
              edit_time: this.$moment(data[i][4], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
              pay_type: data[i][3],
              num: data[i][2]
            });
          }
        }
        var data_s = {
          data: res
        };
        billImportApi(data_s).then(function () {
          _this2.$refs.formBox.tableFrom.search = 0;
          _this2.getTableData();
        });
      }
    },
    getPayType: function getPayType() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                page: 1,
                limit: 0
              };
              _context.next = 3;
              return enterprisePayTypeApi(data);
            case 3:
              result = _context.sent;
              _this3.exportFileUrl = result.data.import_temp;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    arraySpanMethod: function arraySpanMethod(_ref) {
      var row = _ref.row;
      //table合计行合并单元格
      if (row.types === 10) {
        return {
          rowspan: 7,
          colspan: this.tableData.length - 1
        };
      }
    },
    // 导出模板
    exportTemplate: function exportTemplate() {
      this.gettime = this.$moment(new Date()).format('YY-MM-dd hh:mm::ss');
      if (!this.exportFileUrl) {
        this.$message.error('暂无导入模板,请联系管理员');
      } else {
        this.fileLinkDownLoad(this.exportFileUrl, '收支记账导入模板' + this.gettime + '.xlsx');
      }
    },
    // 导出
    getExportData: function getExportData() {
      var _this4 = this;
      this.saveName = '导出账目_' + this.$moment(new Date()).format('MM_DD_HH_mm_ss') + '.xlsx';
      var obj = {};
      for (var key in this.where) {
        obj[key] = this.where[key];
      }
      obj.page = 0;
      obj.limit = 0;
      billListApi(obj).then(function (res) {
        var data = res.data.list;
        var aoaData = [[_this4.$t('finance.accounttabtitle'), _this4.$t('finance.accounttabtype'), _this4.$t('finance.accounttabremark'), _this4.$t('finance.entrytime'), _this4.$t('finance.accountpay'), _this4.$t('finance.accounttabmoney')]];
        if (data.length > 0) {
          data.forEach(function (value) {
            aoaData.push([value.types == 0 ? _this4.$t('finance.pay') : _this4.$t('finance.income'), value.cate ? value.cate.name : '', value.mark, value.edit_time, value.pay_type, value.num]);
          });
          _this4.exportData.data = aoaData;
          _this4.$refs.exportExcel.exportExcel();
        }
      });
    },
    // 查看详情
    handleCheck: function handleCheck(item) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.detailsData = {
                data: item
              };
              setTimeout(function () {
                _this5.$refs.viewDetails.handelOpen();
              }, 300);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 添加科目
    addFinance: function addFinance() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              billListCreateApi().then(function (res) {
                _this6.formBoxConfig = {
                  title: res.data.title,
                  width: '500px',
                  method: res.data.method,
                  action: res.data.action.substr(4)
                };
                _this6.rolesConfig = res.data.rule;
                _this6.$refs.dialogForm.openBox();
              }).catch(function (error) {});
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 编辑
    handleEdit: function handleEdit(item) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              billListEditApi(item.id).then(function (res) {
                _this7.formBoxConfig = {
                  title: res.data.title,
                  width: '500px',
                  method: res.data.method,
                  action: res.data.action.substr(4)
                };
                _this7.rolesConfig = res.data.rule;
                _this7.$refs.dialogForm.openBox();
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getItemArray: function getItemArray(arr, type) {
      var arrs = [];
      arr.map(function (value) {
        if (value.types === type) {
          arrs.push(value);
        }
      });
      return arrs;
    },
    // 删除
    handleDelete: function handleDelete(item, index) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this8.$modalSure(_this8.$t('finance.message4'));
            case 2:
              _context5.next = 4;
              return billListDeleteApi(item.id);
            case 4:
              _this8.getTableData();
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    confirmData: function confirmData(data) {
      this.where.page = 1;
      this.where = _objectSpread(_objectSpread({}, this.where), data);
      if (data.search == 1) {
        this.$refs.formBox.tableFrom.search = 0;
        this.getTableData();
      }
    }
  }
};